import type { CommandeStatus, DevisStatus } from './types';

export const DEVIS_STATUSES: ReadonlyArray<DevisStatus> = [
  'en_attente',
  'valide',
  'rejetee',
];

export const COMMANDE_STATUSES: ReadonlyArray<CommandeStatus> = [
  'en_attente',
  'confirmee',
  'emballee',
  'expediee',
  'livree',
  'retournee',
  'rejetee',
];

export type StatusBadgeVariant = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

export function devisBadgeVariant(status: DevisStatus): StatusBadgeVariant {
  switch (status) {
    case 'valide': return 'success';
    case 'rejetee': return 'danger';
    case 'en_attente':
    default: return 'warning';
  }
}

export function commandeBadgeVariant(status: CommandeStatus): StatusBadgeVariant {
  switch (status) {
    case 'livree': return 'success';
    case 'expediee':
    case 'emballee':
    case 'confirmee': return 'info';
    case 'retournee': return 'neutral';
    case 'rejetee': return 'danger';
    case 'en_attente':
    default: return 'warning';
  }
}

const COMMANDE_TRANSITIONS: Record<CommandeStatus, ReadonlyArray<CommandeStatus>> = {
  en_attente: ['confirmee', 'rejetee'],
  confirmee: ['emballee', 'rejetee'],
  emballee: ['expediee', 'rejetee'],
  expediee: ['livree', 'retournee'],
  livree: ['retournee'],
  retournee: [],
  rejetee: [],
};

export function canCommandeTransition(
  from: CommandeStatus,
  to: CommandeStatus,
): boolean {
  return COMMANDE_TRANSITIONS[from].includes(to);
}

/**
 * Une commande REJETÉE ou RETOURNÉE ne se réalisera pas : le BL déjà créé
 * pour elle doit être supprimé (le stock sorti revient — pour un retour, la
 * marchandise est physiquement rentrée —, et le CA, assis sur les BL, ne
 * compte plus une vente qui n'a pas eu lieu). Décision de Khalil du
 * 01/08/2026 d'inclure les retours : en COD, un colis retourné = pas de
 * vente, même traitement qu'un rejet.
 */
export function commandeStatusRemovesLinkedDelivery(status: CommandeStatus): boolean {
  return status === 'rejetee' || status === 'retournee';
}

const DEVIS_TRANSITIONS: Record<DevisStatus, ReadonlyArray<DevisStatus>> = {
  en_attente: ['valide', 'rejetee'],
  valide: [],
  rejetee: [],
};

export function canDevisTransition(from: DevisStatus, to: DevisStatus): boolean {
  return DEVIS_TRANSITIONS[from].includes(to);
}
